import React, { useContext } from 'react';
import classnames from 'classnames';
import Icon from '../../../icon';
import Context from '../../context';
function Header(props) {
  var context = useContext(Context);
  var prefixCls = context.prefixCls;
  var className = props.className,
    children = props.children,
    prevIcon = props.prevIcon,
    nextIcon = props.nextIcon,
    superPrevIcon = props.superPrevIcon,
    superNextIcon = props.superNextIcon,
    onPrev = props.onPrev,
    onNext = props.onNext,
    onSuperPrev = props.onSuperPrev,
    onSuperNext = props.onSuperNext;
  var iconCls = classnames("".concat(prefixCls, "-header-icon"));
  var textCls = classnames("".concat(prefixCls, "-header-text"));
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, onSuperPrev ? /*#__PURE__*/React.createElement("span", {
    className: iconCls,
    onClick: onSuperPrev
  }, superPrevIcon || /*#__PURE__*/React.createElement(Icon, {
    type: "double-arrow-left"
  })) : /*#__PURE__*/React.createElement("span", {
    className: iconCls
  }), onPrev ? /*#__PURE__*/React.createElement("span", {
    className: iconCls,
    onClick: onPrev
  }, prevIcon || /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-left"
  })) : /*#__PURE__*/React.createElement("span", {
    className: iconCls
  }), /*#__PURE__*/React.createElement("span", {
    className: textCls
  }, children), onNext ? /*#__PURE__*/React.createElement("span", {
    className: iconCls,
    onClick: onNext
  }, nextIcon || /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-right"
  })) : /*#__PURE__*/React.createElement("span", {
    className: iconCls
  }), onSuperNext ? /*#__PURE__*/React.createElement("span", {
    className: iconCls,
    onClick: onSuperNext
  }, superNextIcon || /*#__PURE__*/React.createElement(Icon, {
    type: "double-arrow-right"
  })) : /*#__PURE__*/React.createElement("span", {
    className: iconCls
  }));
}
export default Header;